import { IBaseIconProps } from "./IBaseIconProps";

export const EnvelopeIcon3 = ({ color = "#fff" }: IBaseIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="2.5" y="5" width="19" height="14" rx="2.5" />
      <path d="M3 7.5l9 6 9-6" />
    </svg>
  );
};
